<h2 mat-dialog-title class="dialog-header">
  Payment
  <button mat-icon-button class="close-btn" aria-label="Close" (click)="activeModal.close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="dialog-content">
  <ngx-json-viewer [json]="payment" expanded="true"></ngx-json-viewer>
</mat-dialog-content>
